import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "show-case__top" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 23",
    class: "list-view__item-svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M531.761934,115.991841 L519.574443,105.210588 C519.257035,104.929804 518.742876,104.929804 518.425544,105.210588 C518.108136,105.491372 518.108136,105.946207 518.425544,106.226923 L529.226098,115.781269 L493.812525,115.781269 C493.363416,115.781269 493,116.102753 493,116.500042 C493,116.897331 493.363416,117.218815 493.812525,117.218815 L529.226098,117.218815 L518.425544,126.773093 C518.108136,127.053878 518.108136,127.508712 518.425544,127.789429 C518.58421,127.929787 518.792159,128 519.000032,128 C519.207905,128 519.415778,127.929787 519.57452,127.789429 L531.762011,117.008176 C532.079342,116.727459 532.079342,116.272625 531.761934,115.991841 Z",
      transform: "translate(-493 -105)"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "back-button__text" }, " Tilbage til oversigt", -1)
const _hoisted_4 = { class: "show-case__code-snippet" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
    stroke: "#A3C8D1",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 7V11",
    stroke: "#A3C8D1",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 15H11.01",
    stroke: "#A3C8D1",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Kode eksempel", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "show-case__wrapper" }
const _hoisted_10 = { class: "show-case__teaser" }
const _hoisted_11 = { class: "show-case__header" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "show-case__content" }
const _hoisted_16 = {
  key: 0,
  class: "code-modal"
}
const _hoisted_17 = { class: "code-modal__content" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  id: "icon__close",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M445.90625,422.90625 L434.09375,422.90625 L434.09375,411.09375 C434.09375,410.489672 433.604078,410 433,410 C432.395922,410 431.90625,410.489672 431.90625,411.09375 L431.90625,422.90625 L420.09375,422.90625 C419.489672,422.90625 419,423.395922 419,424 C419,424.604078 419.489672,425.09375 420.09375,425.09375 L431.90625,425.09375 L431.90625,436.90625 C431.90625,437.510328 432.395922,438 433,438 C433.604078,438 434.09375,437.510328 434.09375,436.90625 L434.09375,425.09375 L445.90625,425.09375 C446.510328,425.09375 447,424.604078 447,424 C447,423.395922 446.510328,422.90625 445.90625,422.90625 Z",
    transform: "rotate(45 720.535 -291.9)"
  })
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "Kode eksempel kommer snart", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["show-case", _ctx.data.wrapper ? `${_ctx.data?.wrapper}-wrapper` : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: _ctx.getBackLink,
        class: "back-button"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.data.sourceLink)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal())),
              class: "show-case__code",
              href: _ctx.data.sourceLink,
              target: "_blank"
            }, _hoisted_8, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h1", _hoisted_11, [
          (_ctx.data.title)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.data.title), 1))
            : (!_ctx.data.title && _ctx.path.includes('/animations'))
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Animation "))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, " Komponent "))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.modalActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "code-modal__close-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal()))
              }, _hoisted_19),
              _hoisted_20
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}